<template>
  <div class="brand">
    <div class="container">
      <div class="brand-wrap">
        <div class="content">
          <h3>品牌介绍</h3>
          <h4>BRAND INTRODUCTION</h4>
          <div class="title">
            <p>源于厦门彰泰隔热膜有限公司高端定制品牌</p>
          </div>
          <div class="content">
            <p>
              厦门彰泰隔热有限公司旗下 <strong>雷朋、蓝钻、FSK</strong> 三大主流汽车膜品牌。
              FSK是欧美工业+日本精细化工的成果之作,自80年代始步入窗膜领域,
              历经三十几年积累,持续革新产品及客户服务,淬炼并严选高品质的隔热膜,
              坚持仅由无尘环境来生产无毒无害之产品,并同时引领多种革命性前瞻制
              膜技术的问世,如陶瓷隔热技术、多层颜色复合技术、多层金属喷溅、纳 米涂布、智能光学等;
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.brand {
  display: flex;
  justify-content: center;
  background: url('~@/assets/bg_1.jpg') no-repeat center/cover;
}
.container {
  display: flex;
  justify-content: center;
  .brand-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 100px);
    padding: 0 100px;
    box-sizing: border-box;
    color: #fff;
    & > .content {
      h3,
      h4 {
        text-align: center;
      }
      h3 {
        font-size: 40px;
        margin-top: 0;
        margin-bottom: 20px;
      }
      h4 {
        font-size: 30px;
        margin-top: 0;
        margin-bottom: 40px;
      }
      .title {
        position: relative;
        padding-bottom: 10px;
        margin-bottom: 20px;
        font-size: 36px;
        font-weight: bold;
        p {
          margin-top: 0;
          margin-bottom: 10px;
        }
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 80px;
          height: 4px;
          background-color: #fff;
        }
      }
      .content {
        font-size: 16px;
        p {
          line-height: 2;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .container {
    width: 100%;
    .brand-wrap {
      height: auto;
      padding: 20px;
      .content {
        .title {
          font-size: 30px;
        }
      }
    }
  }
}

@media screen and (max-width: 1199px) {
  .container {
    width: 100%;
  }
}

@media screen and (min-width: 1200px) {
  .container {
    width: 1200px;
  }
}
</style>
